import { z } from 'zod';
/**
 * Validation for a poll's JSONB payload — stored on the `community_content_items.data`
 * column for rows where `item_type = 'poll'`.
 *
 * The shape is intentionally minimal:
 *   - question: short prompt shown above the options
 *   - options: 2..10 client-assigned IDs + labels (IDs are referenced by `poll_votes.option_id`)
 *   - expires_at: optional auto-close timestamp
 *
 * Vote counts are NOT stored here — they're computed from `poll_votes`. Closure
 * state lives on the `polls` table.
 */
export const pollOptionSchema = z
    .object({
    id: z.string().uuid(),
    label: z.string().trim().min(1).max(80),
})
    .strict();
export const pollDataSchema = z
    .object({
    question: z.string().trim().min(1).max(280),
    options: z
        .array(pollOptionSchema)
        .min(2)
        .max(10)
        .refine((opts) => new Set(opts.map((o) => o.id)).size === opts.length, {
        message: 'option ids must be unique',
    }),
    // `nullish` (null OR undefined OR omitted) — the dashboard composer ships
    // `expires_at: null` when the author hasn't picked a close date, which the
    // refine + the polls-row writer both treat as "no expiry".
    expires_at: z.string().datetime({ offset: true }).nullish(),
})
    .strict()
    .refine((data) => !data.expires_at || new Date(data.expires_at).getTime() > Date.now(), { message: 'expires_at must be in the future', path: ['expires_at'] });
/**
 * Body of `POST /v1/groups/:groupId/polls/:contentItemId/vote`.
 * `option_id` must match one of the poll's option IDs (validated at runtime
 * against the stored options).
 */
export const castPollVoteSchema = z
    .object({
    option_id: z.string().uuid(),
})
    .strict();
//# sourceMappingURL=polls.js.map